import React, { useState } from "react";
import { useDropzone } from "react-dropzone";
import { useDispatch, useSelector } from "react-redux";
import {
    resetForm,
    selectFile,
} from "../../Redux/Action/UploadEmployeeAction";
import Loader from "../../component/Admin/Loader";
import { MasterAdminLoader } from "../../Redux/Action/MasterAdminAction";
import VfsLayout from "../../component/layout/VfsLayout/VfsLayout";
import { UploadVfsExcel, ValidateExcel } from "../../Redux/Action/VfsAction";


const VfsCreatemember = () => {

    const dispatch = useDispatch();
    const authToken = localStorage.getItem("Admin");

    const onDrop = (acceptedFiles) => {
        setSelectFile(acceptedFiles[0]);
        setShowUploadButton(false);
    };
    
    const [showUploadButton, setShowUploadButton] = useState(false);
    const [selectedFile, setSelectFile] = useState(null);

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        accept: {
            "text/xlsx": [".xlsx"],
        },
    });

    const loader = useSelector((state) => state?.MasterAdmin?.corporateloader);

    //for validate file
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!selectedFile) {
            dispatch(selectFile("please select a file"));
            return;
        }
        try {
            const Master_CorpoId = JSON.parse(authToken)?.data?.corporateID;
            const formData = new FormData();
            formData.append("file", selectedFile);
            formData.append("master_CorpoId", Master_CorpoId);
            dispatch(ValidateExcel(formData, setSelectFile, setShowUploadButton));
            dispatch(MasterAdminLoader());
            dispatch(resetForm());
        } catch (error) {
        }
    };

    //for upload file
    const handleUpload = async (e) => {
        e.preventDefault();
        if (!selectedFile) {
            dispatch(selectFile("please select a file"));
            return;
        }
        try {
            const Master_CorpoId = JSON.parse(authToken)?.data?.corporateID;
            const formData = new FormData();
            formData.append("file", selectedFile);
            formData.append("master_CorpoId", Master_CorpoId);
            dispatch(UploadVfsExcel(formData, setSelectFile, setShowUploadButton));
            dispatch(MasterAdminLoader());
            dispatch(resetForm());
        } catch (error) {
        }
    };


    return (
        <>
            <VfsLayout>
                {/* for loader  */}
                {loader && (
                    <div>
                        <div className="bg-black fixed  top-0 left-0 right-0 w-full h-full z-[999] bg-opacity-50">
                            <div className="z-[999] absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                                <Loader />
                            </div>
                        </div>
                    </div>
                )}

                <div className="flex flex-col h-full p-5 mb-10">

                    {/* --------------------------------------------Content Table------------------------------------------------------- */}
                    <div className="flex flex-col w-full h-full gap-3">
                        <div className=" text-lg text-[#1A1A1A] font-Roboto">
                            Upload your filled member list file here (.xlsx):<span className="text-[#fc0000] ml-1"> *</span>
                        </div>
                        {/*---------------- For Select File-------------- */}
                        <div className="cursor-pointer ">
                            {" "}
                            <div
                                {...getRootProps({
                                    className:
                                        "flex flex-col items-center justify-center border-2 border-[#808080] border-dashed p-3 py-10  md:p-16 rounded-lg bg-white",
                                })}
                            >
                                <input {...getInputProps()} />
                                <div>
                                    <svg
                                        className="w-8 h-8 mb-4 text-[#808080]"
                                        aria-hidden="true"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 20 16"
                                    >
                                        <path
                                            stroke="currentColor"
                                            d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                                        />
                                    </svg>
                                </div>
                                <p className="text-sm text-[#808080] font-Roboto text-center">
                                    Click to upload the member list file OR drag & drop the file here.
                                </p>
                                {selectedFile && (
                                    <p className=" text-[#808080] font-Roboto mt-3 text-center">
                                        Selected File : {selectedFile.name}
                                    </p>
                                )}
                            </div>
                        </div>

                        {/* -----------------------Button--------------------- */}
                        <div className="items-center justify-center gap-5 mx-auto mt-5 md:flex">
                            <div>
                                <a
                                    href={'https://welcomcure-corporate-image.b-cdn.net/corporate/vfs_sample_file.xlsx'}
                                    className="border border-[#FCDD00] text-[#1A1A1A] bg-white w-[178px]  py-2 rounded-lg font-Roboto flex justify-center"
                                >
                                    Download Sample File
                                </a>
                            </div>
                            <div className="flex justify-center mt-3 md:mt-0">
                                {selectedFile && !showUploadButton && (
                                    <button
                                        onClick={handleSubmit}
                                        className="bg-[#FCDD00] text-[#1A1A1A] px-10 py-2 rounded-lg font-Roboto w-[170px] outline-none"
                                    >
                                        Validate
                                    </button>
                                )}  
                                {showUploadButton &&  <button
                                        onClick={handleUpload}
                                        className="bg-[#FCDD00] text-[#1A1A1A] px-10 py-2 rounded-lg font-Roboto w-[170px] outline-none"
                                    >
                                        Upload
                                    </button>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </VfsLayout>
        </>
    );
};

export default VfsCreatemember;